export const GROUPS_ENTITY = 'admin/program-groups';
export const APP_CONFIGS_ENTITY = 'admin/app-configs';
export const GROUPED_APPS_ENTITY = 'apps/grouped';

// React Query cache tuning. Groups and assignments only change via admin action
// (mutations invalidate these keys, so staleTime never hides a fresh write), and
// the members-facing grouped view changes rarely. Cache for a few minutes so the
// data isn't refetched on every mount / navigation.
export const APP_SETTINGS_STALE_TIME = 5 * 60 * 1000; // 5 minutes
export const APP_SETTINGS_GC_TIME = 10 * 60 * 1000; // 10 minutes
